import { render, staticRenderFns } from "./MarketingAutomationDetail.vue?vue&type=template&id=7147d087&scoped=true"
import script from "./MarketingAutomationDetail.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationDetail.vue?vue&type=script&lang=js"
import style0 from "./MarketingAutomationDetail.vue?vue&type=style&index=0&id=7147d087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7147d087",
  null
  
)

export default component.exports